import {
	GridColumnMenuFilter,
	GridColumnMenuCheckboxFilter,
	GridColumnMenuProps,
	GridColumnProps,
} from "@progress/kendo-react-grid";
import { GrideDateFormatter } from "ui/Date";
import { NumericalCell, NumericalHeader } from "ui/grid/GridCommandCell";
import CellPopover from "ui/grid/DescriptionCell";
import { t } from "i18next";
import { CLASSNAME, ICON_NAMES } from "utils/constant";
import React from "react";
import { PageTypePath } from "utils/pages";
import { PdfType } from "utils/PdfType";
import { formatNorwegianNumber } from "utils/helper";
import { calculateFieldStats } from "utils/statUtils";
import { ColumnMenuCheckboxFilter } from "ui/grid/ColumnMenuFilter";

export const storageStatisticsGridColumnItems = (props: {
	ref: React.RefObject<HTMLDivElement>;
	data: any[];
	filteredDataRef: React.MutableRefObject<any[]>;
}): GridColumnProps[] => {
	const allColumns: GridColumnProps[] = [
		{
			field: "",
			width: "30px",
			cells: {
				data: () => <td></td>,
				headerCell: () => (
					<td>
						<span ref={props.ref}>
							<img
								src={`/icon/${ICON_NAMES.EllispsisVeritcal}.svg`}
								alt="Column dropdown"
								style={{ height: 20, width: 20, cursor: "pointer" }}
							/>
						</span>
					</td>
				),
			},
		},
		{
			field: "landingNoteNumber",
			title: t("LandingNoteNumber"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			width: "200px",
			cells: {
				data: (props) => {
					const handleClick = () => {
						const noteNumber = props.dataItem.landingNoteNumber;
						if (noteNumber.startsWith("60") || noteNumber.startsWith("61")) {
							window.open(
								`/${PageTypePath.Pdf}/${noteNumber}/${PdfType.LandingNote}`,
								"_blank",
							);
							return;
						}
						window.open(
							`/${PageTypePath.Pdf}/${props.dataItem.landingNoteNumber}/${PdfType.SalesNote}`,
							"_blank",
						);
					};
					return (
						<td onClick={handleClick} style={{}}>
							<span
								style={{
									color: "black",
									cursor: "pointer",
									border: "1px solid  #adbac6",
									backgroundColor: "white",
									padding: "5px",
								}}
							>
								{props.dataItem.landingNoteNumber}
							</span>
						</td>
					);
				},
			},
			hidden: true,
		},
		{
			field: "deliveryDateTime",
			title: t("DeliveryDate"),
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.deliveryDateTime}
						formatType={"dd.MM.yyyy"}
					/>
				),
				footerCell: (props) => <td className={""}>{t("Total")}</td>,
				groupFooter: (props) => {
					return (
						<td style={{ marginTop: "20px" }} className={" no-border td-bold"}>
							{t("Total") + " " + props.dataItem.value}
						</td>
					);
				},
			},
			width: "200px",
			hidden: false,
		},
		{
			field: "salesDateTime",
			title: t("SalesDate"),
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.salesDateTime}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
			width: "200px",
			hidden: true,
		},
		{
			field: "registrationId",
			title: t("RegistrationId"),
			width: "150px",
			hidden: true,
		},
		{
			field: "specieCode",
			title: t("SpeciesCode"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			width: "150px",
			hidden: true,
		},
		{
			field: "specieDescription",
			title: t("Species"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			cells: { data: (props) => <CellPopover {...props} /> },
			width: "150px",
			hidden: false,
		},
		{
			field: "productDescription",
			title: t("Product"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			cells: { data: (props) => <CellPopover {...props} /> },
			width: 250,
			hidden: false,
		},
		{
			field: "productConditionCode",
			title: t("Condition"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "productConditionDescription",
			title: t("ConditionDescription"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "productPreservationType",
			title: t("PreservationType"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: false,
		},
		{
			field: "productPackagingCode",
			title: t("Packaging"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "productPackagingDescription",
			title: t("PackagingDescription"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "fishingGearCode",
			title: t("FishingGearCode"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			width: "150px",
			hidden: true,
		},
		{
			field: "fishingGearDescription",
			title: t("FishingGear"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			width: "180px",
			hidden: false,
		},
		{
			field: "catchAreaCode",
			title: t("CatchAreaCode"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "catchAreaDescription",
			title: t("CatchArea"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "terminalCode",
			title: t("TerminalCode"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "terminalDescription",
			title: t("Terminal"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			cells: { data: (props) => <CellPopover {...props} /> },

			width: 250,
			hidden: false,
		},
		{
			field: "vesselRegistrationNumber",
			title: t("VesselRegistrationId"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "vesselDescription",
			title: t("VesselName"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			cells: { data: (props) => <CellPopover {...props} /> },
			width: 170,
			hidden: false,
		},
		{
			field: "vesselLenght",
			title: t("VesselLength"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,

			hidden: true,
		},
		{
			field: "vesselOwnerBusinessRegistrationNumber",
			title: t("VesselOwnerRegistrationNumber"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "vesselOwnerGroupDescription",
			title: t("VesselOwnerGroup"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			cells: { data: (props) => <CellPopover {...props} /> },
			hidden: true,
		},
		{
			field: "year",
			title: t("Year"),
			filter: "numeric",
			filterTitle: "Year",
			hidden: true,
		},
		{
			field: "period",
			title: t("Period"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "month",
			title: t("Month"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "week",
			title: t("Week"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "day",
			title: t("Day"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "msc",
			title: t("MSC"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: false,
		},
		//{
		//	field: "norwegianPreference",
		//	title: t("NorwegianPreference"),
		//	columnMenu: (prop) => (
		//		<ColumnMenuCheckboxFilter {...prop} data={props.data} />
		//	),
		//	hidden: false,
		//},
		{
			field: "turnNumber",
			title: t("Turnummer"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "qualityDescription",
			title: t("Quality"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},

		{
			field: "averageWeight",
			title: t("AverageWeight"),
			filter: "numeric",
			className: `no-border`,
			width: "150",
			cells: {
				data: (props) => <NumericalCell {...props} />,
			},
			headerClassName: "header-menu-numerical",
			hidden: false,
		},

		{
			field: "grossWeight",
			title: t("Weight"),
			columnMenu: ColumnMenu,
			filter: "numeric",
			className: `no-border`,
			width: "150",
			cells: {
				data: (props) => <NumericalCell {...props} />,
				footerCell: (prop) => {
					const minDecimal = 2;
					const maxDecimal = 2;
					return (
						<td className={CLASSNAME.TableNumeric}>
							{formatNorwegianNumber(
								calculateFieldStats(
									props.filteredDataRef.current,
									prop.field as any,
								).sum,
								minDecimal,
								maxDecimal,
							)}
						</td>
					);
				},
				groupFooter: (props) => {
					const minDecimal = 2;
					const maxDecimal = 2;
					let data = props.dataItem.aggregates[props.field as any];
					return (
						<td className={CLASSNAME.TableNumeric}>
							<div
								style={{ marginTop: "20px" }}
								className="no-border td-bold"
							>{`Min: ${formatNorwegianNumber(data.min, minDecimal, maxDecimal)}
											 Avg: ${formatNorwegianNumber(
													data.average,
													minDecimal,
													maxDecimal,
												)} Max:  ${formatNorwegianNumber(
													data.max,
													minDecimal,
													maxDecimal,
												)}`}</div>
						</td>
					);
				},
			},
			headerClassName: "header-menu-numerical",
			hidden: false,
		},
		{
			field: "roundWeight",
			title: t("RoundWeight"),
			columnMenu: ColumnMenu,
			filter: "numeric",
			headerClassName: "header-menu-numerical",
			cells: {
				data: (props) => <NumericalCell {...props} />,
				footerCell: (prop) => {
					const minDecimal = 2;
					const maxDecimal = 2;
					return (
						<td className={CLASSNAME.TableNumeric}>
							{formatNorwegianNumber(
								calculateFieldStats(
									props.filteredDataRef.current,
									prop.field as any,
								).sum,
								minDecimal,
								maxDecimal,
							)}
						</td>
					);
				},
				groupFooter: (props) => {
					const minDecimal = 2;
					const maxDecimal = 2;
					let data = props.dataItem.aggregates[props.field as any];
					return (
						<td style={{}} className={CLASSNAME.TableNumeric}>
							<div style={{ marginTop: "20px" }} className="no-border td-bold">
								{formatNorwegianNumber(data.sum, minDecimal, maxDecimal)}
							</div>
						</td>
					);
				},
			},
			hidden: true,
		},
		{
			field: "numberOfUnits",
			title: t("NumberOfUnits"),
			columnMenu: ColumnMenu,
			filter: "numeric",
			headerClassName: "header-menu-numerical",
			className: `${CLASSNAME.TableNumeric} no-border`,
			cells: {
				data: (props) => <NumericalCell {...props} formatDecimal={0} />,
				footerCell: (prop) => {
					const minDecimal = 0;
					const maxDecimal = 0;
					return (
						<td className={CLASSNAME.TableNumeric}>
							{formatNorwegianNumber(
								calculateFieldStats(
									props.filteredDataRef.current,
									prop.field as any,
								).sum,
								minDecimal,
								maxDecimal,
							)}
						</td>
					);
				},
				groupFooter: (props) => {
					const minDecimal = 0;
					const maxDecimal = 0;
					let data = props.dataItem.aggregates[props.field as any];
					return (
						<td style={{}} className={CLASSNAME.TableNumeric}>
							<div style={{ marginTop: "20px" }} className="no-border td-bold">
								{formatNorwegianNumber(data.sum, minDecimal, maxDecimal)}
							</div>
						</td>
					);
				},
			},
			hidden: true,
		},
		{
			field: "quantity",
			title: t("Quantity"),
			filter: "numeric",
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border `,
			cells: {
				data: (props) => <NumericalCell {...props} formatDecimal={0} />,
				footerCell: (prop) => {
					const minDecimal = 0;
					const maxDecimal = 0;
					return (
						<td className={CLASSNAME.TableNumeric}>
							{formatNorwegianNumber(
								calculateFieldStats(
									props.filteredDataRef.current,
									prop.field as any,
								).sum,
								minDecimal,
								maxDecimal,
							)}
						</td>
					);
				},
				groupFooter: (props) => {
					const minDecimal = 0;
					const maxDecimal = 0;
					let data = props.dataItem.aggregates[props.field as any];
					return (
						<td style={{}} className={CLASSNAME.TableNumeric}>
							<div style={{ marginTop: "20px" }} className="no-border td-bold">
								{formatNorwegianNumber(data.sum, minDecimal, maxDecimal)}
							</div>
						</td>
					);
				},
			},
			hidden: true,
		},
		{
			field: "",
			width: "40px",
		},
	];

	// Set a default width of "150px" for columns missing width
	return allColumns.map((col) => ({
		...col,
		width: col.width ? col.width : "150px",
	}));
};

export const ColumnMenu = (props: GridColumnMenuProps) => {
	return (
		<div style={{ color: "black" }}>
			<GridColumnMenuFilter {...props} expanded={true} />
		</div>
	);
};
